export const nextLesson = (unitKey, lessonKey, units) => {
  console.log('Checking next lesson', unitKey, lessonKey)
  let next = null
  units.forEach((unit, uIndex) => {
    if (unit.key === unitKey) {
      unit.lessons.forEach((lesson, lIndex) => {
        if (lesson.slug === lessonKey) {
          // Last lesson in unit
          if (lIndex === unit.lessons.length - 1) {
            // Last unit
            if (uIndex === units.length - 1) {
              next = null
            } else {
              next = {
                unit: units[uIndex + 1],
                lesson: units[uIndex + 1].lessons[0],
              }
            }
          } else {
            next = {
              unit: unit,
              lesson: unit.lessons[lIndex + 1],
            }
          }
        }
      })
    }
  })
  return next
}
